/* eslint-disable func-names */
/* eslint-disable class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import jsonp from 'jsonp';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
// import { gaWrapper } from 'helpers/analytics';
// eslint-disable-next-line no-unused-vars
import s from './Login.scss';
import Cookie from '../../utils/cookies';
import { LOGIN_MAPPED_ON_LIVE } from '../../constants';

class OnetapsigninV2 extends React.Component {
  constructor() {
    super();
    this.state = {
      signInSuccess: false,
      showSignInSuccess: false,
    };
    this.yoloTimeout = 5000;
    this.clientId =
      '103703403489-b4t4lt8mr05brqpcdrmsu0di54cmjv4f.apps.googleusercontent.com';
    this.OnetapsigninMod = null;
    this.didPromiseReturn = false;
    this.didOneTapPopUpShow = false;
    this.moduleName = 'google_one_tap';
    this.nextShowCookieName = 'oneTapNextShow';
    this.ru = 'bchjqhklhblchbhjglh1wbfbv';
    this.timerID = false;
    this.source = '';
    this.callOneTapSignOnPriority = true;
  }

  componentDidMount() {
    try {
      window.TimesApps.PopUpV2Manager.cmd.push(() => {
        if (
          window.TimesApps.PopUpV2Manager &&
          window.TimesApps.PopUpV2Manager?.register &&
          typeof window.TimesApps.PopUpV2Manager.register === 'function'
        ) {
          window.TimesApps.PopUpV2Manager.register(this.moduleName, () => {
            const { isWapView } = this.props;
            this.channel = isWapView ? 'toi-wap' : 'toi';
            window.addEventListener('onetapsignin', this.initOneTap);
            window.addEventListener('click', this.closeOneTap);
            if (
              typeof window === 'object' &&
              window.TimesGDPR &&
              window.TimesGDPR.common.consentModule.gdprCallback
            ) {
              window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
                if (
                  !(
                    dataObj.isEUuser ||
                    (dataObj.userCountry === 'US' &&
                      dataObj.userRegion === 'CA')
                  ) ||
                  dataObj.consentGiven
                ) {
                  this.loadJs();
                }
              });
            }
          });
        }
      });
    } catch (error) {
      console.log('Error in registering onetap popup');
    }
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.closeOneTap);
    window.removeEventListener('onetapsignin', this.initOneTap);
  }

  initOneTap = e => {
    //append the google oneTap API script to dom
    if (typeof window === 'undefined') {
      return;
    }
    this.callBack = e.customCallBack;
    this.customFallbackFn = e.customFallbackFn;
    this.source = '';
    if (typeof e.source === 'string' && e.source) {
      this.source = e.source;
    }
  };

  closeOneTap = e => {
    // cancel if popup available.
    const el =
      e.target &&
      typeof e.target.closest === 'function' &&
      e.target.closest('#credential_picker_iframe');
    if (!el) {
      this.setTimerToClosePopup();
    }
  };

  loadJs = () => {
    setTimeout(() => {
      (function(d, sc, cb) {
        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.type = 'text/javascript';
        script.async = true;
        script.onload = cb;
        const node = document.getElementsByTagName('script')[0];
        node.parentNode.insertBefore(script, node);
      })(document, 'script', this.initiateAPI);
    }, 100);
  };

  googleCallBack = response => {
    if (typeof response.credential !== 'undefined') {
      const currentDate = new Date();
      // set session for 12 hours
      window.localStorage.setItem(
        'onetap_session',
        currentDate.getTime() + 12 * 60 * 60 * 1000,
      );

      const domainName =
        __PROD__ || LOGIN_MAPPED_ON_LIVE
          ? 'https://jsso.indiatimes.com'
          : 'https://jssostg.indiatimes.com';

      // Send the token to your auth backend.
      const googleLongToken = response.credential;
      const getTicketUrl = `${domainName}/sso/services/gponetaplogin/verify?token=${googleLongToken}&channel=${
        this.channel
      }&ru=${this.ru}`;

      jsonp(getTicketUrl, null, (err, res) => {
        if (err) {
          console.error(err.message);
        } else if (res && res.code === 200) {
          this.setUserLoginSession();
        }
      });
      this.didPromiseReturn = true;
      this.didOneTapPopUpShow = true;
      window.onetapActiveFlag = false;
    }
  };

  setUserLoginSession = () => {
    if (typeof this.callBack === 'function') {
      this.callBack(false, () => {
        this.setState({
          signInSuccess: true,
          showSignInSuccess: true,
        });
        if (typeof window !== 'undefined' && window.location) {
          window.location.reload();
        }
      });
      setTimeout(() => {
        this.hideSignInSuccess();
      }, 10000);
    }
  };

  initiateAPI = () => {
    const ssoid = Cookie.get('ssoid') || Cookie.get('ssoId');
    if (!!ssoid || typeof window.google !== 'object') {
      this.handleSigninFailure();
      return;
    }
    window.google.accounts.id.initialize({
      client_id: this.clientId,
      callback: this.googleCallBack,
      cancel_on_tap_outside: false,
      auto_select: true,
      itp_support: true,
      prompt_parent_id: 'g_id_onload',
      use_fedcm_for_prompt: true,
    });
    window.google.accounts.id.prompt(this.handleGoogleNotificationResponses);
  };
  setTimerToClosePopup = () => {
    if (
      window.google &&
      window.google.accounts &&
      window.google.accounts.id &&
      typeof window.google.accounts.id.cancel === 'function'
    ) {
      window.google.accounts.id.cancel();
      window.onetapActiveFlag = false;
      if (this.timerID) {
        clearTimeout(this.timerID);
      }
    }
  };

  handleGoogleNotificationResponses = notification => {
    const getNotDisplayedReason = notification.getNotDisplayedReason();
    console.log('Google Notification', getNotDisplayedReason);
    // const getSkippedReason = notification.getSkippedReason();
    // const getDismissedReason = notification.getDismissedReason();
    if (notification && notification.g === 'display' && notification.h) {
      if (
        window &&
        window.TimesApps.PopUpList &&
        window.TimesApps.PopUpList[this.moduleName]
      ) {
        window.TimesApps.PopUpList[this.moduleName].callbacks.onShowCallback(
          true,
        );
      }
      this.timerID = setTimeout(this.setTimerToClosePopup, 90000);
      window.onetapActiveFlag = true;
      return;
    }
    // let label = `Success_google_iswap=${this.props.isWapView}`;

    // if (this.source && this.callOneTapSignOnPriority) {
    //   label = `Success_${this.props.isWapView ? 'wap' : 'web'}_${this.source}`;
    // }
    if (
      notification &&
      notification.g === 'dismissed' &&
      notification.i === 'credential_returned'
    ) {
      // analyticsWrapper('gaAndGrx', 'send', 'event', 'Login', 'One_Tap', label);
      analyticsWrapper('ga4', {
        event: 'user_login',
        type: 'google_one_tap',
        category: 'google_one_tap',
        label: 'login',
      });
    }
    if (notification.isNotDisplayed()) {
      this.handleSigninFailure();
    }
  };

  handleSigninFailure = () => {
    if (
      window &&
      window.TimesApps.PopUpList &&
      window.TimesApps.PopUpList[this.moduleName]
    ) {
      window.TimesApps.PopUpList[this.moduleName].callbacks.onShowCallback(
        false,
      );
    }
    const { showCommentsSidebar } = this.props;
    if (typeof showCommentsSidebar === 'function') {
      showCommentsSidebar();
    }
    if (typeof this.customFallbackFn === 'function') {
      this.customFallbackFn();
    }
  };

  hideSignInSuccess = () => {
    this.setState({ showSignInSuccess: false });
  };

  render() {
    if (
      !(
        this.state.signInSuccess &&
        this.props.username &&
        this.state.showSignInSuccess
      )
    ) {
      return null;
    }
    return (
      <div className="onetap_wrapper">
        <span className="success" />
        <span className="text">
          {`Successfully signed in as ${this.props.username}`}
        </span>
        <span className="close" onClick={() => this.hideSignInSuccess()} />
      </div>
    );
  }
}

OnetapsigninV2.propTypes = {
  isWapView: PropTypes.bool,
  username: PropTypes.string,
};

OnetapsigninV2.defaultProps = {
  isWapView: false,
  username: '',
};

export default OnetapsigninV2;
